export function isMissing(value: any): boolean {
  return value === undefined || value === null
}

export function isMissingOrEmpty(value: null | undefined | string | object | Array<any>): boolean {
  if (isMissing(value)) return true
  if (Array.isArray(value)) return value.length === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  if (typeof value === 'string') return value.trim() === ''
  return false
}
